import Group from 'components/utils/Group'
import Image from 'components/Common/Image'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import TextButton from 'LuxKit/Button/TextButton'
import LineExternalLinkAltIcon from 'LuxKit/Icons/line/LineExternalLinkAltIcon'

const EMPTY_STATE_IMAGE_ID = 'cvbrvk7aefcowhr5spzd'

interface Props {
  imageAlt: string
  heading: string
  body: string
  ctaLabel: string
  searchUrl: string
  isBodyCentered?: boolean
}

function ListingDrawerEmptyState({
  imageAlt,
  heading,
  body,
  ctaLabel,
  searchUrl,
  isBodyCentered = false,
}: Props) {
  return (
    <Group direction="vertical" gap={16} horizontalAlign="center">
      <Image
        id={EMPTY_STATE_IMAGE_ID}
        width={399}
        height={168}
        alt={imageAlt}
        format="gif"
      />
      <Group direction="vertical" gap={8} horizontalAlign="center">
        <Heading variant="heading5">{heading}</Heading>
        <BodyText
          variant="medium"
          colour="light-foreground-alt"
          align={isBodyCentered ? 'center' : undefined}
        >
          {body}
        </BodyText>
      </Group>
      <TextButton
        kind="primary"
        shape="round"
        endIcon={<LineExternalLinkAltIcon />}
        href={searchUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {ctaLabel}
      </TextButton>
    </Group>
  )
}

export default ListingDrawerEmptyState
